var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"message-header-wrapper"},[_c('span',{staticClass:"u-b2--"},[_vm._v(_vm._s(_setup.messageHeaderInfo))]),_c(_setup.ChatKebabOptions,{attrs:{"should-button-have-border":false,"chat-action-list":_vm.chatActionList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }